(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["table-of-content"] && !Shopify.designMode) return;
  try {
    document.addEventListener("DOMContentLoaded", function () {
  // Get all content sections
  const contentSections = document.querySelectorAll('[id^="section-"]');
  const tocList = document.querySelector('[data-toc-list]');
  
  // Create TOC entries
  contentSections.forEach(section => {
    const heading = section.querySelector('.accordion-header');
    if (heading) {
      const li = document.createElement('li');
      const a = document.createElement('a');
      a.href = `#${section.id}`;
      a.textContent = heading.textContent;
      li.appendChild(a);
      tocList.appendChild(li);
    }
  });

  // Highlight active section on scroll
  const tocLinks = document.querySelectorAll('.toc-sidebar a');
  
  function setActiveLink() {
    const fromTop = window.scrollY + 150; // Offset for header

    contentSections.forEach(section => {
      const id = section.getAttribute('id');
      const link = document.querySelector(`.toc-sidebar a[href="#${id}"]`);
      
      if (!link) return;

      const rect = section.getBoundingClientRect();
      
      if (rect.top <= 150 && rect.bottom > 150) {
        link.classList.add('active');
      } else {
        link.classList.remove('active');
      }
    });
  }

  // Handle smooth scrolling
  tocLinks.forEach(link => {
    link.addEventListener('click', (e) => {
      e.preventDefault();
      const targetId = link.getAttribute('href');
      const targetSection = document.querySelector(targetId);
      
      if (targetSection) {
        targetSection.scrollIntoView({
          behavior: 'smooth'
        });
      }
    });
  });

  // Update active state on scroll
  window.addEventListener('scroll', () => {
    requestAnimationFrame(setActiveLink);
  });

  // Setup accordion functionality
  const headers = document.querySelectorAll(".accordion-header");
  headers.forEach(header => {
    header.addEventListener("click", function () {
      const content = header.nextElementSibling;
      content.classList.toggle("active");
    });
  });
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["toolbar"] && !Shopify.designMode) return;
  try {
    (function() {
  const toolbar = document.querySelector('.toolbar');
  if (!toolbar) return;


  const toolbarLinks = toolbar.querySelectorAll('.toolbar__link');
  if (toolbarLinks.length === 0) return;

  // Get all target sections
  const sections = [];
  toolbarLinks.forEach(link => {
    const href = link.getAttribute('href');
    if (href && href.startsWith('#')) {
      const targetId = href.substring(1);
      const section = document.getElementById(targetId) || document.querySelector(`[id="${targetId}"]`);
      if (section) {
        sections.push({ link, section, id: targetId });
      }
    }
  });

  if (sections.length === 0) return;

  // Track user interaction with toolbar to prevent auto-scroll interference
  let isUserScrollingToolbar = false;
  let toolbarScrollTimeout = null;
  const toolbarNav = toolbar.querySelector('.toolbar__nav');

  // Detect when user is manually scrolling the toolbar
  if (toolbarNav) {
    toolbarNav.addEventListener('touchstart', () => {
      isUserScrollingToolbar = true;
      if (toolbarScrollTimeout) {
        clearTimeout(toolbarScrollTimeout);
      }
      // Reset flag after user stops interacting (with delay to prevent immediate auto-scroll)
      toolbarScrollTimeout = setTimeout(() => {
        isUserScrollingToolbar = false;
      }, 1000);
    }, { passive: true });

    toolbarNav.addEventListener('touchmove', () => {
      isUserScrollingToolbar = true;
      if (toolbarScrollTimeout) {
        clearTimeout(toolbarScrollTimeout);
      }
      toolbarScrollTimeout = setTimeout(() => {
        isUserScrollingToolbar = false;
      }, 1000);
    }, { passive: true });

    toolbarNav.addEventListener('scroll', () => {
      isUserScrollingToolbar = true;
      if (toolbarScrollTimeout) {
        clearTimeout(toolbarScrollTimeout);
      }
      toolbarScrollTimeout = setTimeout(() => {
        isUserScrollingToolbar = false;
      }, 500);
    }, { passive: true });
  }

  // Remove active class from all links
  function removeAllActive() {
    toolbarLinks.forEach(link => link.classList.remove('active'));
  }

  // Check if element is visible within its scrollable container
  function isElementVisible(element, container) {
    const elementRect = element.getBoundingClientRect();
    const containerRect = container.getBoundingClientRect();

    return (
      elementRect.left >= containerRect.left &&
      elementRect.right <= containerRect.right
    );
  }

  // Set active link based on section in view
  function setActiveLink(targetId, skipAutoScroll = false) {
    removeAllActive();
    const activeLink = toolbar.querySelector(`.toolbar__link[href="#${targetId}"]`);
    if (activeLink) {
      activeLink.classList.add('active');

      // Only auto-scroll toolbar if user is not manually scrolling and link is not visible
      if (!skipAutoScroll && toolbarNav && !isUserScrollingToolbar) {
        requestAnimationFrame(() => {
          const listItem = activeLink.closest('.toolbar__item');

          if (listItem && !isElementVisible(listItem, toolbarNav)) {
            // Only scroll if the link is not already visible
            const pageScrollY = window.scrollY;

            // Use scrollTo for more control instead of scrollIntoView
            const containerRect = toolbarNav.getBoundingClientRect();
            const itemRect = listItem.getBoundingClientRect();
            const scrollLeft = toolbarNav.scrollLeft;
            const itemLeft = itemRect.left - containerRect.left + scrollLeft;
            const itemWidth = itemRect.width;
            const containerWidth = containerRect.width;

            // Calculate scroll position to center the item
            const targetScroll = itemLeft - (containerWidth / 2) + (itemWidth / 2);

            toolbarNav.scrollTo({
              left: targetScroll,
              behavior: 'smooth'
            });

            // Ensure page scroll position doesn't change
            if (window.scrollY !== pageScrollY) {
              window.scrollTo(0, pageScrollY);
            }
          }
        });
      }
    }
  }

  // Update active state based on scroll position
  function updateActiveOnScroll() {
    const scrollOffset = 150; // Offset for header
    const scrollPosition = window.scrollY + scrollOffset;

    let activeSection = null;
    let minDistance = Infinity;

    sections.forEach(({ section, id }) => {
      const rect = section.getBoundingClientRect();
      const sectionTop = rect.top + window.scrollY;
      const sectionBottom = sectionTop + rect.height;

      // Check if section is currently in viewport
      if (scrollPosition >= sectionTop && scrollPosition <= sectionBottom) {
        const distance = Math.abs(scrollPosition - sectionTop);
        if (distance < minDistance) {
          minDistance = distance;
          activeSection = id;
        }
      }
    });

    // If no section is in view, find the closest one above
    if (!activeSection) {
      sections.forEach(({ section, id }) => {
        const rect = section.getBoundingClientRect();
        const sectionTop = rect.top + window.scrollY;

        if (scrollPosition >= sectionTop) {
          const distance = scrollPosition - sectionTop;
          if (distance < minDistance) {
            minDistance = distance;
            activeSection = id;
          }
        }
      });
    }

    if (activeSection) {
      setActiveLink(activeSection);
    }
  }

  // Handle smooth scrolling on link click
  toolbarLinks.forEach(link => {
    link.addEventListener('click', (e) => {
      const href = link.getAttribute('href');
      if (href && href.startsWith('#')) {
        const targetId = href.substring(1);
        const targetSection = document.getElementById(targetId) || document.querySelector(`[id="${targetId}"]`);

        if (targetSection) {
          e.preventDefault();
          const headerOffset = 100; // Offset for sticky header if present
          const elementPosition = targetSection.getBoundingClientRect().top;
          const offsetPosition = elementPosition + window.pageYOffset - headerOffset;

          // Temporarily prevent auto-scroll of toolbar when user clicks
          isUserScrollingToolbar = true;
          if (toolbarScrollTimeout) {
            clearTimeout(toolbarScrollTimeout);
          }
          toolbarScrollTimeout = setTimeout(() => {
            isUserScrollingToolbar = false;
          }, 1500);

          // Set active link without auto-scrolling toolbar
          setActiveLink(targetId, true);

          window.scrollTo({
            top: offsetPosition,
            behavior: 'smooth'
          });
        }
      }
    });
  });

  // Update active state on scroll with throttling
  let ticking = false;
  function handleScroll() {
    if (!ticking) {
      requestAnimationFrame(() => {
        updateActiveOnScroll();
        ticking = false;
      });
      ticking = true;
    }
  }

  window.addEventListener('scroll', handleScroll, { passive: true });

  // Initial check
  updateActiveOnScroll();
})();
  } catch(e) { console.error(e); }
})();

})();
